export enum PlanType {
  Syndicate,
  CoOwner,
  Corporate,
}